import PageComponent from '../PageComponent';
import Glide from '@glidejs/glide';

export default class Blog extends PageComponent {
    init() {
        this.ready();
    }

    ready() {
        let video = this.element.find('video'),
            play = this.element.find('.play-overlay');

        video.on('click', function () {
            video[0].pause();
            play.show();
        });

        play.on('click', function () {
            video[0].play();
            play.hide();
        });

        let slider = this.element.find('.gallery');
        new Glide(slider[0], {
            type: 'carousel',
            startAt: 0,
            perView: 1,
            gap: 0
        }).mount();
    }
}
